const SUBCATEGORY_GRID_XLRG = 1239;
const SUBCATEGORY_GRID_LRG = 1059;
const SUBCATEGORY_GRID_MED = 799;
const SUBCATEGORY_GRID_SML = 599;

export const SLIDER_BREAKPOINTS = [
    {
        breakpoint: SUBCATEGORY_GRID_XLRG,
        slides: 4
    },
    {
        breakpoint: SUBCATEGORY_GRID_LRG,
        slides: 3
    },
    {
        breakpoint: SUBCATEGORY_GRID_MED,
        slides: 2
    },
    {
        breakpoint: SUBCATEGORY_GRID_SML,
        slides: 1
    }
];
